<template>
  <div class="container">
    <div
      class="create-complete"
    >
      <div>
        <img :src="`${$root.cdnUrl}assets/icon-complete.svg`">
      </div>
      <div>
        <h4 class="complete-title">
          Tebrikler Ürününüz Listenize Eklenerek Onaya Gönderildi!
        </h4>
        <div class="complete-subtitle">
          Müşterilerimize en doğru bilgilerle satışa sunmak amacıyla,
          Trendyol'da listelenen tüm ürünler kontrol edilmektedir.
          Kontrol süreci ortalama 3 iş günü içerisinde tamamlanacaktır.
          <span @click="backToList">Ürün Listesi</span>
          ekranı üzerinden onay durumunu takip edebilirsiniz.
        </div>
      </div>

      <button
        class="btn btn-trendyol"
        @click="addProduct"
        type="button"
      >
        YENİ ÜRÜN EKLE
      </button>
    </div>
  </div>
</template>

<script>
import mobile from '@/utils/mobile';
import { mapActions } from 'vuex';

export default {
  name: 'ProductComplete',
  methods: {
    ...mapActions({
      resetAttributes: 'singleProduct/resetAttributes',
    }),
    addProduct () {
      this.resetAttributes();
      this.$router.push({
        name: 'ProductInfo',
      });
    },
    backToList () {
      mobile.navigationNavigate({
        pageName: 'Product',
        params: { reload: Date.now(), barcode: this.$route.query.barcode },
      });
    },
  },
  created () {
    this.$root.trackEvent({
      eventCategory: 'MobileAppListing',
      eventAction: 'ÜrünListesiDropdownMenüAçanlar',
      eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEklemeBasarılıMesajı',
    });
    this.$emit('onEndEvent');
  },
};
</script>

<style lang="scss" scoped>
  .create-complete {
    text-align: center;
    padding: 50px 0;

    .complete-title {
      font-size: 18px;
      font-weight: 500;
      color: #0bc15c;
      margin-bottom: 30px;
    }
    .complete-subtitle{
      color: rgb(39, 49, 66);
      margin-bottom: 50px;
      span {
        color: rgb(242, 122, 26);
        border-bottom: 1px solid rgb(242, 122, 26);
      }
    }
  }
</style>
